import { TotalReturnCard } from '@/components/PerformanceCardsContainer/components/TotalReturnCard';
import { TotalReturnDetails } from '@/components/PerformanceCardsContainer/components/TotalReturnDetails';
import {
  useGetOrganizationAutomationsPerformance,
  useOrganizationTotalReturn,
} from '@/modules/Organizations/queries/get-organization-automations-peformance';
import { useMemo, useState } from 'react';
import { DateRange } from 'react-day-picker';

type OrganizationTotalReturnCardProps = {
  organizationId: number;
  automationPerformanceDateRange?: DateRange;
};

export const OrganizationTotalReturnCard = ({
  organizationId,
  automationPerformanceDateRange,
}: OrganizationTotalReturnCardProps) => {
  const [dateRange, setDateRange] = useState<DateRange>();
  const [searchInput, setSearchInput] = useState<string>();
  const [isDetailsOpen, setDetailsOpen] = useState<boolean>(false);

  const { data: automationPerformance, isLoading } =
    useGetOrganizationAutomationsPerformance(
      organizationId,
      automationPerformanceDateRange,
    );

  const {
    data,
    isLoading: isLoadingTotalReturnAutomated,
    fetchNextPage,
    isFetching,
    isFetchingNextPage,
  } = useOrganizationTotalReturn({
    organizationId,
    enabled: isDetailsOpen,
    dateRange,
    filter: searchInput,
  });

  const totalReturnAutomated = useMemo(
    () => data?.pages.flat() || [],
    [data?.pages],
  );

  return (
    <TotalReturnCard
      automationPerformance={automationPerformance}
      isLoading={isLoading}
      setIsDetailsOpen={setDetailsOpen}
      details={
        isDetailsOpen && (
          <TotalReturnDetails
            isLoading={isLoadingTotalReturnAutomated}
            totalReturnAutomated={totalReturnAutomated}
            onClose={() => setDetailsOpen(false)}
            additionalTableColumns
            fetchNextPage={fetchNextPage}
            dateRange={dateRange}
            setDateRange={setDateRange}
            setSearchInput={setSearchInput}
            isFetching={isFetching}
            isFetchingNextPage={isFetchingNextPage}
          />
        )
      }
    />
  );
};
